import React from "react";

export default class GeneralWarningModal extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
        <div className="alert alert-warning">
          <p style={{ marginTop: 5 }} className="text-center"><strong>{this.props.translatedString}</strong></p>
          <hr />
        </div>
    );
  };

};